// import 'normalize.css/normalize.css';
// import 'promise-polyfill/src/polyfill';
// import 'babel-polyfill';
import 'url-search-params-polyfill';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import './components/base/croppa/vue-croppa.css';
import Croppa from './components/base/croppa/vue-croppa';
import App from './App';
import router from './router';
import store from './store';
import { imgRotate, getEnd } from './tools/utils';
import './tools/onelink-smart-script';

import VueCookies from 'vue-cookies';
import initSentry from 'sentry';
import {i18nInit, i18nGet as i, i18nLoading} from '@didi/i18n-plugin';
import { addSupportWebpClass, VueImageForGiftV3, getImageResizeUrl } from '@didi/webcube';
addSupportWebpClass('webp');
Vue.component('img-v3', VueImageForGiftV3);
Vue.prototype.$getImageResizeUrl = function (url) {
  return getImageResizeUrl(url, true)
},
i18nInit (require ('./locales/i18n-info'));

if (getEnd() === 'FleetPCEnd') {
  // console.log('getEnd()', getEnd())
  import('./plugins/element.js')
}

if (getEnd() === 'WebEnd') {
  import('./tools/web2app.js');
}

import {
  Style,
  Toast,
  Dialog,
  Picker,
  DatePicker,
  Drawer,
  Checker,
  Scroll,
  Select,
  Popup
} from 'cube-ui';

Vue.use (Popup);
Vue.use (Toast);
Vue.use (Dialog);
Vue.use (Picker);
Vue.use (DatePicker);
Vue.use (Drawer);
Vue.use (Checker);
Vue.use (Scroll);
Vue.use (Select);
Vue.use (VueI18n);
Vue.use (Croppa);
Vue.use (VueCookies);

initSentry()


const renderApp = () => {
  let lang = new URLSearchParams (location.search).get ('lang');
  const i18n = new VueI18n ({
    locale: lang,
    fallbackLocale:'default',
    messages: {
      'pt-BR': i (require ('./locales/pt-br/transition.json'), 'pt-br'),
      'es-MX': i (require ('./locales/es-mx/transition.json'), 'es-mx'),
      'es-CO': i (require ('./locales/es-co/transition.json'), 'es-co'),
      'es-CL': i (require ('./locales/es-cl/transition.json'), 'es-cl'),
      'es-PE': i (require ('./locales/es-pe/transition.json'), 'es-pe'),
      'es-CR': i (require ('./locales/es-cr/transition.json'), 'es-cr'),
      'en-US': i (require ('./locales/en-us/transition.json'), 'en-us'),
      'ru-RU': i (require ('./locales/ru-ru/transition.json'), 'ru-ru'),
      'es-AR': i (require ('./locales/es-ar/transition.json'), 'es-ar'),
      'es-419': i (require ('./locales/es-419/transition.json'), 'es-419'),
      'ja-JP': i (require ('./locales/ja-jp/transition.json'),'ja-jp'),
      'uk-UA': i (require ('./locales/uk-ua/transition.json'), 'uk-ua'),
      default: i (require ('./locales/en-us/transition.json'), lang),
    },
  });

  const app = new Vue ({
    el: '#app',
    i18n,
    router,
    store,
    render: h => h (App),
  });
};


new Promise (resolve => {
  //todo set i18n
  function check () {
    if (
      window.innerWidth &&
      window.innerHeight &&
      screen.availWidth &&
      screen.availHeight
    ) {
      resolve ();
    } else {
      setTimeout (check, 10);
    }
  }
  if (
    ['complete', 'loaded', 'interactive'].includes (document.readyState) &&
    document.body
  ) {
    check ();
  } else {
    document.addEventListener ('DOMContentLoaded', check, false);
  }
}).then (() => {
  //解决promise axios请求，finally不执行的问题
  Promise.prototype.finally = function (callback) {
    let P = this.constructor;
    return this.then (
      value => P.resolve (callback ()).then (() => value),
      reason =>
        P.resolve (callback ()).then (() => {
          throw reason;
        })
    );
  };
  (function (doc, win) {
    var docEle = doc.documentElement,
      resizeEvent = 'orientationchange' in window
        ? 'orientationchange'
        : 'resize';
    var recalCulate = function () {
      var width = docEle.clientWidth;
      var size = 50 * (width / 375);
      docEle.style.fontSize = (size > 60 ? 60 : size) + 'px';
    };
    recalCulate ();
    if (!doc.addEventListener) return;
    win.addEventListener (resizeEvent, recalCulate, false);
    imgRotate();
  }) (document, window);
  i18nLoading (e => {
    console.log (e);
  }).then (renderApp);
});
